export enum PaymentFeeType {
  Bid = "Bid",
  Publish = "Publish",
  Subscription = "Subscription",
}

export enum PaymentStorageVariable {
  Khalti = "khalti-redirect-path",
  Esewa = "esewa-redirect-path",
}

export enum Role {
  Bidder = "Bidder",
  Publisher = "Publisher",
}

export enum PaymentStatus {
  Pending = "pending",
  Submitted = "submitted",
}

export enum BidStatus{
  IN_PROGRESS = 'In_progress',
  SUBMITTED = 'Submitted',
  EOI_STATUS = "EOI_Status",
  ENLISTING = "Enlisiting",
  WITH_DRAWN_OR_AWARDED="Withdrawn_or_awarded"
}

export enum EOIStatus {
  Submitted = "Submitted",
  Pass = "Pass",
  Fail = "Fail",
}

export enum FileSize {
  'MAX_FILE_SIZE'= 100000000,
  "MAX_FILE_SIZE_WORD"= "File size exceeds maximum limit of 100 mb"
}

